import
{
    FC,
    PropsWithChildren
} from "react";

import
{
    env
} from "./Environment";

type FeatureProps = PropsWithChildren & {
    feature: 'TRVB' | 'SIMULATE_USER' | 'SETTINGS_TEMPLATE';
};

type Environment = 'development' | 'staging' | 'production';

const getEnvironment = (): Environment =>
{

    const { hostname } = new URL(env.APP_SERVICE_URL);

    if (hostname.toLowerCase().endsWith('ews.lstwien')) return 'development';
    if (hostname.toLowerCase().endsWith('ews.lst.at')) return 'staging';
    if (hostname.toLowerCase().endsWith('staging.newreact.com')) return 'staging';

    return 'production';
};

const Feature: FC<FeatureProps> = ({
    feature,
    children
}) =>
{
    const environment = getEnvironment();

    switch (feature) {
        case 'TRVB':
        case 'SETTINGS_TEMPLATE':
        case 'SIMULATE_USER':
            if (environment === 'production') return <></>;
            break;

    }

    return <>{children}</>;
};

export default Feature;
